/**
 * Main wizard ctrl
 */
angular.module("wizard").controller("wizard.WizardInitCtrl", ['$rootScope', '$state', function ($rootScope, $state) {
   $state.go('wizard');
}]);

/**
 * Wizard page
 */
angular.module("wizard").controller("wizard.WizardPageCtrl", ['settings', '$rootScope', '$scope', '$state', '$location', '$stateParams', 'usersService', 'companiesService', 'appMenuService','resourcesService', function (settings, $rootScope, $scope, $state, $location, $stateParams, usersService, companiesService, appMenuService, resourcesService) {
    var context = this;
    context.settings = settings;
    context.maxPage = 1;

    appMenuService.setHideAppMenu(true);

    usersService.getCurrentUser().then(function (user) {
        context.currentPage = 0;
        context.pageReady = true;
        context.currentStateName = $state.$current.name;
        var userType = "";
        if (angular.isDefined(user.childUser) && user.childUser === true) {
            userType = "childUser";
        } else if (user.getRightAsBoolean("IS_CORPORATE_USER")) {
            userType = "corporate";
        } else if (user.getRightAsBoolean("IS_SERVICE_PROVIDER_USER")) {
            userType = "provider";
        } else {
            userType = "noUser";
        }
        context.userType = userType;

        //redirect if the profile is already complete
        /*
        if(angular.isDefined(user.userData) && user.userData.completedProfile) {
            $location.path("/dashboard");
            return;
        }
         */

        $scope.$on('$destroy', function () {
            appMenuService.setHideAppMenu(false);
        });

        // broadcast status name to template to display step message (I wanted to avoid moving wizard functionality
        // to related controllers as much as possible.)
        $rootScope.$on('$stateChangeSuccess', function () {
            context.currentStateName = $state.$current.name;
            context.pageReady = true;
        });

        /* TODO: Seems that this is not used at all and can be removed!
        $rootScope.$on('contactDataWizardPage', function (ev, data) {
          var nextPage = 2;
          switchPage(nextPage, data);

        });

        $rootScope.$on('availabilityWizardPage', function (ev, data) {
            var nextPage = 3;
            switchPage(nextPage, data);
        });

        $rootScope.$on('skillsAndBranchesWizardPageWizardPage', function (ev, data) {
            var nextPage = 4;
            switchPage(nextPage, data);
        });

        $rootScope.$on('consultantSummaryWizardPage', function (ev, data) {
            var nextPage = 5;
            switchPage(nextPage, data);
        });

        $rootScope.$on('certificatesAndLanguagesWizardPage', function (ev, data) {
            var nextPage = 6;
            switchPage(nextPage, data);
        });

        $rootScope.$on('referencesWizardPage', function (ev, data) {
            var nextPage = 7;
            switchPage(nextPage, data);
        });

        $rootScope.$on('educationWizardPage', function (ev, data) {
            var nextPage = 8;
            switchPage(nextPage, data);
        });

        $rootScope.$on('residenceWizardPage', function (ev, data) {
            var nextPage = 9;
            switchPage(nextPage, data);
        });

        $rootScope.$on('submitProfileWizardPage', function (ev, data) {
            var nextPage = 10;
            switchPage(nextPage, data);
        });
        */

        $rootScope.$on('phoneNumberVerified', function (ev, data) {
            var nextPage = 4;
            switchPage(nextPage, data);
        });

        $rootScope.$on('pageCompleted', function (ev, data) {
            var nextPage = context.currentPage + 1;
            if (typeof data.page !== "undefined") {
                nextPage = data.page + 1;
            }
            if (nextPage>context.maxPage) {
                context.maxPage = nextPage-1;
            }
            switchPage(nextPage, data);
        });

        var switchPage = function (page, switchEventData) {
            switch (context.userType) {
                case "corporate":
                    switch (page) {
                        case 0:
                            $state.go('wizard.companyIntro');
                            break;
                        case 1:
                            $state.go('wizard.userSettings');
                            break;
                        case 2:
                            $state.go('wizard.companyProfile');
                            break;
                        case 3:
                            if (context.settings.phoneVerificationRequested) {
                                $state.go('wizard.phoneVerification');
                                break;
                            }
                        case 4:
                            usersService.setUserCompletedProfile(true).then(function () {
                                usersService.clearCurrentUserCache();
                                //appMenuService.setHideAppMenu(false);
                                // GTM implementation
                                if (typeof dataLayer != 'undefined') {
                                    dataLayer.push ({'event':'registration','category':'company','status':'successfulRegistration'});
                                }

                                $state.go('wizard.companyFinished'); // the aim why I do not redirect here is mainly to reset stateParams
                            });

                            break;
                    }
                    break;

                case "provider":
                   // now in separate controller
                    break;

                case "childUser":
                    switch (page) {
                        case 1:
                            $state.go('wizard.userSettings');
                            break;
                        //case 2: //no verification now
                        //    $state.go('wizard.phoneVerification');
                        //    break;
                        case 2:
                            usersService.setUserCompletedProfile(true).then(function () {
                                usersService.clearCurrentUserCache();
                                //appMenuService.setHideAppMenu(false);

                                $state.go('wizard.complete'); // the aim why I do not redirect here is mainly to reset stateParams
                            });
                            break;
                    }
                    break;


                // no user (no authorized from wizard will dispatch login dialog)
                case "noUser":

                    break;

            }
            context.pageReady = false;
            context.currentPage = page;
        };

        let initialPage = (context.settings.showIntro) ? 0 : 1;
        switchPage(initialPage, {});

    });
}]);

angular.module("wizard").controller("wizard.WizardCompleteCtrl", ['$location', function ($location) {
    $location.path("/dashboard"); // go to dashboard
}]);

/**
 * Freelancer wizard.
 */
angular.module("wizard").controller("wizard.WizardFreelancerCtrl", ['$location', '$scope', '$rootScope', '$timeout', '$window', '$templateCache', 'usersService', 'wizardService', 'uploadService', 'resourcesService', 'geocodingService', 'othersService', 'appMenuService', 'limitToFilter', '$anchorScroll', function ($location, $scope, $rootScope, $timeout, $window, $templateCache, usersService, wizardService, uploadService, resourcesService, geocodingService, othersService, appMenuService, limitToFilter, $anchorScroll) {
    var context = this;
    context.wizardStep = 1;
    context.countriesForPhoneVerification = {preferredCountries: null, localizedCountries: {}, onlyCountries: null};
    context.profileData = {};
    context.settings = {};
    context.formErrors = {};
    context.intlTelInstance = {};


    context.newReference = {referenceType: 'freelancerExperience', categories: [{}]};
    context.referencesEditMode = false;
    context.numberOfRequiredReferences = 0;

    context.pageReady = false;
    context.select2Options = {minimumResultsForSearch: -1};
    appMenuService.setHideAppMenu(true);

    othersService.getCountries().then(function (response) {
        context.countriesList = response;
    });
    othersService.getIndustries().then(function (response) {
        context.industries = response;
    });
    othersService.getFeaturedCategories(true).then(function (response) {
        context.featuredCategories = response;
    });

    wizardService.getWizardFreelancerData().then(function (response) {
        context.profileData = response.item;
        context.profileData.availabilityNextDate = new Date(response.item.availabilityNextDate);

        wizardService.getWizardSettings().then(function (settings) {
            context.settings = settings;
            if (context.settings.showIntro) {
                context.wizardStep = 0;
            }
        });

        othersService.getCountriesForPhoneVerification().then(function (data) {
            context.countriesForPhoneVerification.localizedCountries = data.localizedCountries;
            context.countriesForPhoneVerification.onlyCountries = data.onlyCountries;
            context.countriesForPhoneVerification.preferredCountries = data.preferredCountries;
            context.pageReady = true;
        });

    });

    context.sendLanguagesAndSaveData = function (stepName) {
        var promise = null;
        if (angular.isDefined(context.newLanguage) && context.newLanguage !== null &&
            angular.isDefined(context.newLanguage.skillLevel) && context.newLanguage.skillLevel !== null &&
            angular.isDefined(context.newLanguage.languageId && context.newLanguage.languageId !== null)) {
            promise = context.addLanguage()
                .then(function (response) {
                    return angular.isDefined(response.success) && response.success;
                });
        }
        if (promise === null) {
            context.saveWizardData(stepName);
        }
        else {
            return promise.then(function (success) {
                if(success) {
                    context.saveWizardData(stepName);
                }
            });
        }
    };

    context.sendSkillsAndSaveData = function (stepName) {
        var promise = null;
        if ((!angular.isDefined(context.profileData.skipReferences) || !context.profileData.skipReferences) &&
            angular.isDefined(context.newReference) && context.newReference !== null &&
            angular.isDefined(context.newReference.position)) {
            promise = context.saveReference().then(function (response) {
                return angular.isDefined(response.success) && response.success;
            });
        }

        if (promise === null) {
            context.saveWizardData(stepName);
        }
        else {
            return promise.then(function (success) {
                if(success) {
                    context.saveWizardData(stepName);
                }
            });
        }
    };

    context.saveWizardData = function (stepName) {
        let postData = angular.copy(context.profileData);
        if (!context.intlTelInstance.isValidNumber()) {
            postData.phone = undefined;
        }
        wizardService.saveWizardFreelancerData(postData, stepName).then(function (response) {
            if (angular.isDefined(response.success)) {
                if (response.success) {
                    context.profileData = response.item;
                    context.formErrors = {};
                    context.wizardStep++;
                    $anchorScroll();
                    if (!context.settings.phoneVerificationRequested && context.wizardStep == 5) { //last step  (no phone verification)
                        $rootScope.$emit('wizard.freelancerFinished');
                    }
                }
                else if (angular.isDefined(response.validationErrors)) {
                    context.formErrors = response.validationErrors;
                }
            }
        });
    };

    context.startWizard = function () {
        context.wizardStep = 1;
    }

    context.changeWizardStep = function (step) {
        if (step > 0 && step < context.wizardStep) {
            context.wizardStep = step;
        }
    };

    $rootScope.$on('phoneNumberVerified', function (ev, data) {
        context.wizardStep++;
        $rootScope.$emit('wizard.freelancerFinished');
    });

    $rootScope.$on('wizard.freelancerFinished', function (ev, data) {
        usersService.setUserCompletedProfile(true).then(function () {
            // GTM implementation
            if (typeof dataLayer != 'undefined') {
                dataLayer.push ({'event':'registration','category':'freelancer','status':'successfulRegistration'});
            }

            //$timeout(function() {
            $templateCache.remove("dashboard/dashboard.tpl");
            usersService.clearCurrentUserCache();
            $rootScope.$emit('reloadUser'); //reload user data because of rights change

            //$window.location.replace("/dashboard");
            //appMenuService.setHideAppMenu(false);
            //}, 3500);
        });
    });

    context.addSkill = function () {
        if (typeof context.newSkill == "undefined" || context.newSkill === null || context.newSkill.name === null || context.newSkill.expYears === null) {
            return;
        }

        var postData = angular.copy(context.newSkill);
        postData.profileId = context.profileData.profileRecordId;
        return resourcesService.saveSkill(postData).then(function (response) {
            if (angular.isDefined(response.success)) {
                if (response.success) {
                    context.skillFormErrors = null;
                    if (context.profileData.skillOffers === null) {
                        context.profileData.skillOffers = [];
                    }
                    context.profileData.skillOffers.push({id: response.id, name: postData.name, expYears: postData.expYears});
                    context.newSkill = null;
                }
                else if (angular.isDefined(response.validationErrors)) {
                    context.skillFormErrors = response.validationErrors;
                }
            }
            return response;
        });
    };
    context.removeSkill = function (index, skillId) {
        resourcesService.removeSkill(skillId).then(function (response) {
            if (response.success) {
                context.profileData.skillOffers.splice(index, 1);
            }
        });
    };

    context.addLanguage = function () {
        if (context.newLanguage.skillLevel === null) {
            return;
        }

        var postData = angular.copy(context.newLanguage);
        postData.profileId = context.profileData.profileRecordId;
        return resourcesService.saveLanguage(postData).then(function (response) {
            if (angular.isDefined(response.success)) {
                if (response.success) {
                    context.languageFormErrors = null;
                    if (context.profileData.languages === null) {
                        context.profileData.languages = [];
                    }
                    context.profileData.languages.push({id: response.id, languageId: postData.languageId, languageName: response.name, skillLevel: postData.skillLevel, skillLevelDescription: response.skillLevel});
                    context.newLanguage = {};
                    $scope.$broadcast('languageAdded');
                }
                else if (angular.isDefined(response.validationErrors)) {
                    context.languageFormErrors = response.validationErrors;
                }
            }
            return response;
        });
    };
    context.removeLanguage = function (index, languageId) {
        resourcesService.removeLanguage(languageId).then(function (response) {
            if (response.success) {
                context.profileData.languages.splice(index, 1);
            }
        });
    };
    context.onLanguageSelect = function () {
        context.newLanguage.skillLevel = null;
        context.languageFormErrors = null;
    };

    context.saveReference = function () {
        return resourcesService.saveReference(context.profileData.profileRecordId, context.newReference).then(function (response) {
            if (angular.isDefined(response.success)) {
                if (response.success) {
                    context.referenceFormErrors = null;
                    if (context.profileData.references === null) {
                        context.profileData.references = [];
                    }
                    if (typeof context.newReference.editIndex == "undefined" || context.newReference.editIndex === null) {
                        context.profileData.references.push(response.reference);
                    }
                    else {
                        context.profileData.references[context.newReference.editIndex] = response.reference;
                    }
                    context.newReference = context.newReference = {referenceType: 'freelancerExperience', categories: [{}]};
                    context.referencesEditMode = false;
                }
                else if (angular.isDefined(response.validationErrors)) {
                    context.referenceFormErrors = response.validationErrors;
                }
            }
            return response;
        });
    };
    context.deleteReference = function (referenceId) {
        resourcesService.removeReference(referenceId).then(function (response) {
            if (response.success) {
                let index = context.findReferenceIndexById(referenceId);
                context.profileData.references.splice(index, 1);
            }
        });
    };
    context.addNewReference = function () {
        context.newReference = context.newReference = {referenceType: 'freelancerExperience', categories: [{}]};
        context.referencesEditMode = true;
    };
    context.editReference = function (referenceId) {
        if (context.profileData.references !== null && context.profileData.references.length > 0) {
            let editIndex = context.findReferenceIndexById(referenceId);
            context.newReference = (editIndex !== null) ? context.profileData.references[editIndex] : null;
            context.newReference.editIndex = editIndex;
            context.referencesEditMode = context.newReference !== null;
        }
    };
    context.findReferenceIndexById = function(referenceId) {
        if (context.profileData.references !== null && context.profileData.references.length > 0) {
            for (let i = 0; i < context.profileData.references.length; i++) {
                //existing item
                if (angular.isDefined(context.profileData.references[i]) && context.profileData.references[i].id == referenceId) {
                    return i;
                }
            }
        }
        return null;
    }
    context.ongoingChanged = function(){
        if (context.newReference.ongoing) {
            context.newReference.endMonth = null;
            context.newReference.endYear = null;
        }
    }

    context.cancelReferenceEdit = function () {
        context.newReference = context.newReference = {referenceType: 'freelancerExperience', categories: [{}]};
        context.referenceFormErrors = null;
        context.referencesEditMode = false;
    };
    context.skipReferenceEdit = function () {
        //context.newReference = context.newReference = {referenceType: 'freelancerExperience', categories: [{}]};
        context.referenceFormErrors = null;
        context.profileData.skipReferences = true;
        context.sendSkillsAndSaveData('skills');
    };
    context.skipPersonalSummary = function () {
        context.referenceFormErrors = null;
        context.profileData.personalSummary = null;
        context.sendSkillsAndSaveData('personalSummary');
    };


    context.getSkills = function (term) {
        return othersService.getSkills(term).then(function (response) {
            return limitToFilter(response, 100);
        });
    };
    context.onSkillSelect = function (item, model, label, index) {
        context.newSkill = {id: item.id, name: item.text};
    };

    context.addQualificationRow = function () {
        if (typeof context.newReference.categories == "undefined") {
            context.newReference.categories = [];
        }

        if (context.newReference.categories.length < 3) {
            //warning: in template is used "skill !== {}"
            // - fix before change of following line!
            context.newReference.categories.push({});
        }
    };
    context.removeQualificationRow = function (index) {
        if (typeof context.newReference.categories[index] != "undefined") {
            context.newReference.categories.splice(index, 1);
        }
        if (typeof context.referenceFormErrors != "undefined" && context.referenceFormErrors !== null && typeof context.referenceFormErrors['categories[' + index + '].name'] != "undefined") {
            context.referenceFormErrors['categories[' + index + '].name'] = null;
        }
    };
    context.onQualificationCategorySelect = function (item, model, index) {
        if (!angular.isDefined(item) || item === null) {
            return;
        }

        context.newReference.categories[index] = {
            category: {
                id: item.id,
                name: item.name,
                featuredCategory: item.id !== null
            }
        };
        if (item.id !== null) {
            context.newReference.categories[index].name = item.name;
        } else {
            context.newReference.categories[index].name = null;
        }
    };
    context.onQualificationSkillSelect = function (item, model, label, index) {
        context.newReference.categories[index].name = item.text;
        context.newReference.categories[index].skill = {id: item.id, name: item.text};
    };

    //contact data - city
    context.getLocations = function (country, term) {
        if (term.length > 2) {
            return geocodingService.findByCityName(country, term).then(function (response) {
                return response;
            });
        }
    };

    context.getLocationsByZip = function (country, term) {
        if (term.length > 2) {
            return geocodingService.findByPostalCode(country, term).then(function (response) {
                return response;
            });
        }
    };

    context.onLocationSelect = function (targetLocationObj, item, $model, $label) {
        targetLocationObj.zip = item.postal_code;
        targetLocationObj.city = item.place_name;
        targetLocationObj.county = item.admin_name_1;
        targetLocationObj.latitude = item.lat;
        targetLocationObj.longitude = item.lon;
    };

    context.locationChanged = function (targetLocationObj) {
        targetLocationObj.county = "";
        targetLocationObj.latitude = "";
        targetLocationObj.longitude = "";
        targetLocationObj.locationId = null;
    };

    // datepicker
    context.availabilityDatepickerOpened = false;
    context.toggleAvailabilityDatepicker = function ($event) {
        $event.preventDefault();
        $event.stopPropagation();
        context.availabilityDatepickerOpened ^= true;
    };

    othersService.getLanguagesAndLevels().then(function (response) {
        context.languages = response.languages;
        context.languageLevels = response.levels;
    });


    context.initExperienceYearsData = function (step) {
        var expYears = [];
        for (var i=0; i<30; i++) {
            expYears[i] = {k: i+1, v: i+1};
        }
        (expYears[29]).v = (expYears[29]).v + "+";
        context.skillExpYears = expYears;
    };
    context.initExperienceYearsData();


    // picture upload
    context.uploadProfilePicture = function () {
        resourcesService.uploadProfilePicture(context.profileData);
    };
    context.removeImage = function (profileId) {
        resourcesService.deleteProfilePicture(profileId).then(function (resp) {
            context.profileData.picture = null;
        });
    };
    context.uploadingPicture = false;
    context.upload = function (elm, item) {
        context.uploadingPicture = true;
        var csrfToken = $("input[name='csrfToken']").val();
        uploadService.uploadAvatar(elm, csrfToken).then(function (response) {
            if (response && response.success) {
                context.profileData.picture = response.file;
                //picture uploaded - update reference in profile
                if (context.profileData.id) { // no need to autosave picture when profile was not saved yet
                    resourcesService.updateProfilePicture(context.profileData.id, response.file).then(function (resp) {
                        context.uploadingPicture = false;
                    });
                } else {
                    context.uploadingPicture = false;
                }

            } else if (response && !response.success && response.message) {
                flash.addMessage('', response.message, "warning");
            }
        });
    };
    $scope.uploadAvatar = function (elem) {
        elem = $(elem);
        context.upload(elem);
    };
    context.deletePicture = function () {
        context.profileData.picture = "";
    };

}]);


/** COMPANY WIZARD **/
angular.module("wizard").controller("wizard.WizardCompanyIntroCtrl", ['$location', '$scope', '$rootScope', '$timeout', '$window', '$templateCache', 'usersService', 'wizardService', 'uploadService', 'resourcesService', 'geocodingService', 'othersService', 'appMenuService', 'limitToFilter', '$anchorScroll', function ($location, $scope, $rootScope, $timeout, $window, $templateCache, usersService, wizardService, uploadService, resourcesService, geocodingService, othersService, appMenuService, limitToFilter, $anchorScroll) {
    let context = this;

    context.startWizard = function() {
        $scope.$emit('pageCompleted', {controller: "wizard.WizardCompanyIntroCtrl", page: 0});
    };
}]);

angular.module("wizard").controller("wizard.WizardCompanyFinishedCtrl", ['$location', '$scope', '$rootScope', '$timeout', '$window', '$templateCache', 'usersService', 'wizardService', 'uploadService', 'resourcesService', 'geocodingService', 'othersService', 'appMenuService', 'limitToFilter', '$anchorScroll', function ($location, $scope, $rootScope, $timeout, $window, $templateCache, usersService, wizardService, uploadService, resourcesService, geocodingService, othersService, appMenuService, limitToFilter, $anchorScroll) {
    let context = this;

    // $location.path("/dashboard"); // go to dashboard
}]);

/** phone verification **/
angular.module("wizard").controller("wizard.PhoneVerificationCtrl", ['usersService', 'wizardService', 'othersService', 'flash', '$scope', '$rootScope', function (usersService, wizardService, othersService, flash, $scope, $rootScope) {
    let context = this;
    context.pageReady = false;
    context.countriesForPhoneVerification = {preferredCountries: null, localizedCountries: {}, onlyCountries: null};
    context.settings = wizardService.getWizardSettings().then(function(settings) {
        context.settings = settings;
        context.userId = settings.userId;
        context.phoneNumber = settings.phoneNumber;
        context.verificationToken = null;

        if (settings.phoneVerified || !settings.phoneVerificationRequested) { //already verified or verification not requested = next step
            nextWizardStep();
            return;
        }

        context.phoneVerificationSend(); //send the verification SMS now
        context.pageReady = true;
    });

    othersService.getCountriesForPhoneVerification().then(function (data) {
        context.countriesForPhoneVerification.localizedCountries = data.localizedCountries;
        context.countriesForPhoneVerification.onlyCountries = data.onlyCountries;
        context.countriesForPhoneVerification.preferredCountries = data.preferredCountries;
    });

    context.updatePhoneNumberValidationErrors = null;
    context.phoneVerificationTokenValidationErrors = null;


    let nextWizardStep = function() {
        $scope.$emit('phoneNumberVerified', {controller: "wizard.PhoneVerificationCtrl", page:3});
    };


    context.updatePhoneNumber = function() {
        context.updatePhoneNumberValidationErrors = null;
        usersService.updatePhoneNumber(context.userId, context.phoneNumber).then(function (response) {
            if (!response.success && angular.isDefined(response.validationErrors)) {
                context.updatePhoneNumberValidationErrors = response.validationErrors;
            }
            if (response.message) {
                flash.addMessage('', response.message, response.success ? "success" : "danger", true, true);
            }
            if (response.success) {
                context.phoneVerificationSend();
                context.phoneNumberEdit = false;
            }
        });
    };

    context.phoneVerificationSend = function() {
        usersService.phoneVerificationSend(context.userId, context.phoneNumber).then(function (response) {
            if (response.message) {
                flash.addMessage('', response.message, response.success ? "success" : "danger", true, true);
            }
        });
    };

    context.phoneVerificationCheck = function() {
        usersService.phoneVerificationCheck(context.userId, context.phoneNumber, context.verificationToken).then(function (response) {
            if (response.success) {
                nextWizardStep();
            }
            else if (angular.isDefined(response.validationErrors)) {
                context.phoneVerificationTokenValidationErrors = response.validationErrors;
            }
            if (response.message) {
                flash.addMessage('', response.message, response.success ? "success" : "danger", true, true);
            }
        });
    };

}]);
